<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { FormRecordsContext, FormRecordsContexts } from '@/composables/useFormsFields'

	defineProps<{
		items: FormRecordsContexts
		itemCls?: ClassNameValue
		inputCls?: ClassNameValue
		tag?: string
	}>()
	const form = defineModel<RecordSchema>({ required: true })
	defineEmits<{
		(e: 'change', value: unknown): void
	}>()
	const cls = computed(() => String(useAttrs().class))
	defineOptions({
		inheritAttrs: false
	})
	const filterKey = (item: FormRecordsContext) => {
		const { hidden, ...rest } = item
		return rest
	}
</script>

<template>
	<component :is="tag || 'div'" :class="cls">
		<template v-for="(item, index) in items" :key="item?.form_name || `form-item-${String(index)}`">
			<template v-if="item && !item?.hidden">
				<li v-if="tag === 'ul'" :class="cn(itemCls, item?.itemClass)">
					<slot v-bind="item">
						<form-item
							v-bind="filterKey(item)"
							v-model:value="form[item.form_name]"
							:wrapper-class="[item?.wrapperClass, itemCls]"
							:input-class="[inputCls, item.inputClass]"
							@change="$emit('change', $event)"
						>
							<template #[item.form_name]>
								<slot name="label" v-bind="item" />
								<slot :name="item.form_name" v-bind="item" />
							</template>
						</form-item>
					</slot>
				</li>
				<template v-else>
					<slot v-bind="item">
						<form-item
							v-bind="filterKey(item)"
							v-model:value="form[item.form_name]"
							:wrapper-class="[item?.wrapperClass, itemCls]"
							:input-class="[inputCls, item.inputClass]"
							@change="$emit('change', $event)"
						>
							<template #[item.form_name]>
								<slot name="label" v-bind="item" />
								<slot :name="item.form_name" v-bind="item"> </slot>
							</template>
						</form-item>
					</slot>
				</template>
			</template>
		</template>
	</component>
</template>
